import instance from "./api";

export const fetchAllPrices = async () => {
  const res = await instance.get("/dashboard/all-prices");
  return res.data;             
};

export const fetchDailyEarn = async () => {
  const res = await instance.get("/dashboard/daily-earn");
  return res.data;             
};

export const fetchMonthlyEarn = async () => {
  const res = await instance.get("/dashboard/monthly-earn");
  return res.data;             
};

export const fetchRecentTrips = async () => {
  const res = await instance.get("/dashboard/recent-trips");
  return res.data;             
};

export const updateVehiclePrice = (car_class, body) =>
  instance.post(`/dashboard/upsert-price`, {
    car_class,
    ...body,
  });
